class Faq {
  init () {
    $('.onglets-item, .onglets-mobile-item').on('click', function (event) {
      event.preventDefault()

      const selectedCat = $(this).data('slug')

      $('.faq-item').addClass('hidden')

      $('.faq-item[data-faq-cat="' + selectedCat + '"]').removeClass('hidden')

      $('.expand').removeClass('open').attr('data-expand-init', '')
      $('.expand .expand-content').css({
        maxHeight: '0',
        overflow: 'hidden'
      })

      $('.expand:first-child').addClass('open').attr('data-expand-init', 'open')
      $('.expand:first-child .expand-content').css({
        maxHeight: '100%',
        overflow: 'visible'
      })
    })

    $('.onglets-item:first').click()

    $('.scroll-to-faq').on('click', function (e) {
      e.preventDefault()

      const faqId = $(this).data('faq-id')
      console.log('faqid', faqId)
      const baseUrl = $(this).data('base-url')
      const redirectUrl = baseUrl + '#' + faqId

      window.location.href = redirectUrl
    })

    if (window.location.hash) {
      const faqIdFromUrl = window.location.hash.substring(1)
      const faqElement = $('#' + faqIdFromUrl)
      console.log('faqIdFromUrl', faqIdFromUrl)

      if (faqElement.length) {
        $('.expand').removeClass('open').attr('data-expand-init', '')
        $('.wrapper-content.expands .faq-item').not(faqElement).addClass('hidden')
        faqElement.closest('.faq-item').removeClass('hidden')

        $('.onglets-list li .onglets-item').removeClass('active')
        const faqCat = faqElement.closest('.faq-item').data('faq-cat')
        $('.onglets-list li .onglets-item[data-slug="' + faqCat + '"]').addClass('active')

        const selectedCat = $('.onglets-item.active').data('slug')

        $('.faq-item').each(function () {
          const faqCat = $(this).data('faq-cat')
          if (faqCat !== selectedCat) {
            $(this).addClass('hidden')
          } else {
            $(this).removeClass('hidden')
          }
        })

        faqElement.addClass('open')
        const faqExpandContent = faqElement.find('.expand-content')

        faqExpandContent.addClass('full-height')

        faqElement[0].scrollIntoView()
      }
    }

    const $block = $('.espace-adherent-content')
    this.handlePodcastHeights($block)
  }

  handlePodcastHeights ($block) {
    setInterval(() => {
      this.calculPodcastHeight($block)
    }, 1000)
  }

  calculPodcastHeight ($block) {
    $block.find('.card-document.card-document .card-document-iframe').each((index, iframeInner) => {
      const width = $(iframeInner).innerWidth() + 10
      if (this.cardInnerWidth === width) {
        return
      }
      this.cardInnerWidth = width
      const innerWidth = width
      const W = 500
      const H = 225
      const scale = innerWidth / W
      const height = H * scale
      // const heightScale = height * scale
      $block.find('.card-document-iframe-inner').css(
        {
          transform: 'scale(' + scale + ')',
          height: height + 125
        })
      $block.find('.card-document-iframe').css(
        {
          'padding-top': height + 'px'
        }
      )
    })
  }
}

export default Faq
